import { observer } from "mobx-react";
import React from "react";
import DatePicker from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";

const MultiDatePicker = observer(
  ({ label, value, onChange, placeholder, multiple, errorname, isDisable }) => {
    return (
      <>
        <div className="title">{label}</div>
        <div>
          <DatePicker
            {...(multiple ? { multiple: true } : {})}
            value={value}
            onChange={onChange}
            plugins={[<DatePanel />]}
            placeholder={placeholder}
            disabled={isDisable}
            style={{
              width: "100%",
              height: "100%",
              boxSizing: "border-box",
              padding: "10px",
            }}
            containerStyle={{
              width: "100%",
              height: "100%",
            }}
          />
          <div className="error">{errorname ? errorname : ""}</div>
        </div>
      </>
    );
  }
);

export default React.memo(MultiDatePicker);
